// import React, { useCallback, useEffect, useRef, useState } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { ArrowLeft, Search, RotateCcw, ChevronRight, Loader2, Filter, FileText, RefreshCcw } from 'lucide-react';
// import { swSearchProjects, swGetSuggestedFilters } from '../../services/reportingHubApi';

// const PAGE_SIZE = 10;

// const SoftwareSearch = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const restored = useRef(!!location.state);
//   const restoredState = useRef(!!location.state);
//   const [chips, setChips] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const debounceRef = useRef(null);

//   const [keywords, setKeywords] = useState(
//     location.state?.keywords || ''
//   );

//   const [selectedFilters, setSelectedFilters] = useState(
//     location.state?.selectedFilters || []
//   );

//   const [results, setResults] = useState(
//     location.state?.results || []
//   );

//   const [total, setTotal] = useState(
//     location.state?.total || 0
//   );

//   const [offset, setOffset] = useState(
//     location.state?.offset || 0
//   );



//   const toggleFilter = (token) =>
//     setSelectedFilters((prev) => (prev.includes(token) ? prev.filter((t) => t !== token) : [...prev, token]));
//   const reset = () => { setKeywords(''); setSelectedFilters([]); };

//   const loadChips = useCallback(async (kw, filters) => {
//     try {
//       const data = await swGetSuggestedFilters({ keywords: kw, filters });
//       setChips(data.chips || []);
//     } catch { /* non-critical */ }
//   }, []);

//   const runSearch = useCallback(async (kw, filters, nextOffset = 0, append = false) => {
//     setLoading(true);
//     setError('');
//     try {
//       const data = await swSearchProjects({ keywords: kw, filters, offset: nextOffset, limit: PAGE_SIZE });
//       setTotal(data.total || 0);
//       setOffset(nextOffset);
//       setResults((prev) => (append ? [...prev, ...(data.items || [])] : data.items || []));
//     } catch (e) {
//       setError(e.response?.status === 503 ? 'Source database unavailable.' : 'Search failed, please retry.');
//       if (!append) setResults([]);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     if (restoredState.current) {
//       restoredState.current = false;
//       loadChips(keywords, selectedFilters);
//       return;
//     }

//     if (debounceRef.current) clearTimeout(debounceRef.current);

//     debounceRef.current = setTimeout(() => {
//       runSearch(keywords, selectedFilters, 0, false);
//       loadChips(keywords, selectedFilters);
//     }, 300);

//     return () => clearTimeout(debounceRef.current);
//   }, [keywords, selectedFilters, runSearch, loadChips]);

//   const showMore = () => runSearch(keywords, selectedFilters, offset + PAGE_SIZE, true);
//   const hasMore = results.length < total;
//   const groupedChips = React.useMemo(() => {
//   const order = ["Year", "ProductType", "Vendor", "Platform"];
 
//   const grouped = chips.reduce((acc, chip) => {
//      if (!acc[chip.category]) acc[chip.category] = [];
//      acc[chip.category].push(chip);
//      return acc;
//    }, {});
 
//    return order.map((category) => grouped[category] || []);
//  }, [chips]);

//   return (
//     <div className="min-h-screen bg-black text-white p-2 sm:p-2 md:p-2 lg:px-5 lg:py-4 mb-1">
//       <div className="w-full mx-auto">

//         <div className="flex items-center gap-2 sm:gap-3 pb-3 sm:pb-4 border-b border-gray-400 sm:mb-5 sm:-ml-4">
//           <button
//             onClick={() => navigate('/project-reporting')}
//             className="p-1 sm:p-2 rounded-full hover:bg-gray-800 transition-colors flex-shrink-0"
//             aria-label="Go back"
//           >
//             <ArrowLeft className="w-4 h-4 sm:w-5 sm:h-5 md:w-7 md:h-7 font-bold" />
//           </button>

//           <h1
//             className="
//       text-sm
//       sm:text-lg
//       md:text-2xl
//       lg:text-3xl
//       xl:text-4xl
//       font-bold
//       leading-tight
//       break-words
//     "
//           >
//             Project Reporting Hub_Software
//           </h1>
//         </div>

//         <div className="flex items-center gap-2">
//           <Filter className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-blue-600" />
//           <label className="font-semibold p-2 text-xs sm:text-sm md:text-base lg:text-lg">
//             Keyword search
//           </label>
//         </div>

//         <div className="flex flex-col sm:flex-row gap-3 sm:mb-5">
//           {/* Search Bar */}
//           <div className="relative flex-1">
//             <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 sm:w-5 sm:h-5 text-black" />
//             <input
//               value={keywords}
//               onChange={(e) => setKeywords(e.target.value)}
//               placeholder="Search by project ID, project name, region, platform, vendor, model name"
//               className="
//         w-full
//         bg-white
//         text-black
//         rounded-lg
//         pl-10 sm:pl-11
//         pr-4
//         py-2.5 sm:py-3
//         text-sm sm:text-base
//         outline-none
//         focus:ring-2
//         focus:ring-blue-500
//       "
//             />
//           </div>

//           {/* Mobile Reset Button */}
//           <div className="flex justify-end sm:hidden">
//             <button
//               onClick={reset}
//               className="
//         flex items-center gap-1
//         px-3 py-2
//         rounded-lg
//         bg-gray-700
//         hover:bg-gray-600
//         transition-colors
//         text-sm
//       "
//             >

//               Reset
//               <RefreshCcw className="w-4 h-4" />
//             </button>
//           </div>

//           {/* Desktop Reset Button */}
//           <button
//             onClick={reset}
//             className="
//       hidden sm:flex
//       items-center gap-2
//       px-4 py-3
//       rounded-lg
//       bg-gray-700
//       hover:bg-gray-600
//       transition-colors
//       whitespace-nowrap
//     "
//           >

//             Reset
//             <RefreshCcw className="w-4 h-4" />
//           </button>
//         </div>

//         <div className="flex items-center gap-2">
//           <Filter className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-blue-600" />
//           <label className="font-semibold p-2 text-xs sm:text-sm md:text-base lg:text-lg">
//             Suggested filters
//           </label>
//         </div>

//         <div className="mb-3 pb-3 sm:pb-4 md:pb-7 border-b-2 border-gray-400">
//           {chips.length === 0 ? (
//             <span className="text-gray-500 text-sm">No suggestions</span>
//           ) : (
//             groupedChips.map(
//               (row, index) =>
//                 row.length > 0 && (
//                   <div
//                     key={index}
//                     className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-2 mb-2"
//                   >
//                     {row.map((chip) => {
//               const active = selectedFilters.includes(chip.token);

//               return (
//                 <button
//                   key={`${chip.category}-${chip.token}`}
//                   onClick={() => toggleFilter(chip.token)}
//                   title={`${chip.category} · ${chip.count}`}
//                   className={`w-full px-1.5 sm:px-3 py-1 sm:py-2 rounded-full text-[10px] sm:text-xs md:text-sm font-medium transition-colors truncate ${
//                     active
//                       ? "bg-gray-500 text-white"
//                       : "bg-white text-black hover:bg-gray-200"
//                   }`}
//                 >
//                   {chip.token}
//                 </button>
//               );
//             })}
//           </div>
//         )
//     )
//   )}
//         </div>

//         <hr className="border-gray-800 mb-4" />
//         <div className="flex items-center justify-between mb-1">
//           <div className="flex items-center gap-2">
//             <FileText className="w-6 h-6 sm:w-5 sm:h-5 md:w-6 md:h-6 text-blue-600" />

//             <h2 className="block font-semibold p-2 text-xs sm:text-sm md:text-base lg:text-lg">
//               Results{" "}
//               {total > 0 && (
//                 <span className="text-gray-400 text-sm">
//                   ({total})
//                 </span>
//               )}
//             </h2>
//           </div>

//           <span className="block font-semibold p-2 text-xs sm:text-sm md:text-base lg:text-base text-gray-200">
//             Tips: Add keywords or select more filters to narrow down the list
//           </span>
//         </div>

//         {error && <div className="bg-red-900/40 border border-red-700 text-red-200 rounded-lg px-4 py-3 mb-4">{error}</div>}

//         <div className="space-y-2">
//           {results.map((p) => (
//             <button
//               key={p.projectId}
//               // onClick={() =>
//               //   navigate(`/reporting-hub/software/${p.projectId}`)
//               // }
//               onClick={() =>
//                 // navigate(`/reporting-hub/hardware/${p.projectId}`)
//                 navigate(`/reporting-hub/software/${p.projectId}`, {
//                   state: {
//                     keywords,
//                     selectedFilters,
//                     results,
//                     total,
//                     offset
//                   }
//                 })
//               }
//               className="
//         w-full
//         flex flex-col sm:flex-row
//         sm:items-center sm:justify-between
//         gap-2
//         px-3 sm:px-4 md:px-5
//         py-3 sm:py-4
//         bg-black
//         hover:bg-gray-800
//         border-b-2 border-dotted border-gray-400
//         text-left
//         transition-colors
//         text-white
//       "
//             >
//               <span
//                 className="
//           font-mono
//           text-xs sm:text-sm md:text-base
//           break-words
//           w-full
//           text-white
//         "
//               >
//                 #{p.projectId}, {p.name}
//               </span>

//               <ChevronRight
//                 className="
//           w-5 h-5 sm:w-7 sm:h-7
//           text-gray-400
//           self-end sm:self-center
//           flex-shrink-0
//         "
//               />
//             </button>
//           ))}
//         </div>

//         {loading && <div className="flex items-center justify-center py-6 text-gray-400">
//           <Loader2 className="sm:w-15 sm:h-15 w-6 h-6 animate-spin text-blue-800" />
//         </div>}
//         {!loading && results.length === 0 && !error && <div className="text-center text-gray-500 py-10">No projects found.</div>}
//         {hasMore && !loading && (
//           <div className="flex justify-center mt-5">
//             <button onClick={showMore} className="px-6 py-2 rounded-lg bg-gray-700 hover:bg-gray-600">Show more</button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default SoftwareSearch;


import React, { useState, useRef, useEffect } from "react";
import { getCertandSW } from "../../services/apiService";
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft, ChevronDown } from "lucide-react";

const ProjectReportingHub = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [years, setYears] = useState([]);
  const [projects, setProjects] = useState([]);
  const [allProjects, setAllProjects] = useState([]);
  const [selectedYears, setSelectedYears] = useState([]);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [selectedProjectData, setSelectedProjectData] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const yearRef = useRef(null);
  const projectRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        yearRef.current &&
        !yearRef.current.contains(e.target) &&
        projectRef.current &&
        !projectRef.current.contains(e.target)
      ) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
  loadCertAndSWData();
}, []);


const loadCertAndSWData = async () => {
  try {
    const response = await getCertandSW("Cert and SW Project Template");

    if (response.success) {
      const projectData = (response.data?.projects || response.projects || []).map(
        (item) => {
          const match = item.project.match(/^#(\d+),(.*)$/);

          return {
            year: item.year.toUpperCase(),
            projectId: match ? Number(match[1]) : null,

            // Full text from Excel
            project: item.project,

            // Name without ID (optional)
            projectName: match ? match[2].trim() : item.project,
          };
        }
      );

      setAllProjects(projectData);

      // Unique years (case-insensitive)
      const uniqueYears = [
        ...new Set(
          projectData.map((item) => item.year.toUpperCase())
        ),
      ];

      setYears(uniqueYears);
    }
  } catch (error) {
    console.error("Failed to load Cert & SW data:", error);
  }
};

useEffect(() => {
  if (!selectedYears.length) {
    setProjects([]);
    return;
  }

  const filtered = allProjects.filter(
    (item) =>
      item.year.toUpperCase() === selectedYears[0].toUpperCase()
  );

  setProjects(filtered);
}, [selectedYears, allProjects]);

useEffect(() => {
  if (!location.state || allProjects.length === 0) return;

  const {
    year,
    projectId,
    selectedProject,
    project,
  } = location.state;

  if (year) {
    setSelectedYears([year.toUpperCase()]);
  }

  const matchedProject =
    allProjects.find(
      (item) =>
        String(item.projectId) === String(projectId)
    ) ||
    allProjects.find(
      (item) => item.project === project
    );

  if (matchedProject) {
    setSelectedProjects([matchedProject.project]);
    setSelectedProjectData(matchedProject);
  } else if (selectedProject) {
    setSelectedProjects([selectedProject.project]);
    setSelectedProjectData(selectedProject);
  }
}, [location.state, allProjects]);


  const handleSelect = (item, selected, setSelected) => {
    if (selected.includes(item)) {
      setSelected(selected.filter((i) => i !== item));
    } else {
      setSelected([...selected, item]);
    }
  };


  const renderDropdown = ({
  label,
  options,
  selected,
  setSelected,
  type,
  refObj,
}) => (
  <div className="relative w-full" ref={refObj}>
    <label className="block text-white text-lg font-semibold mb-3">
      {label}
    </label>

    <button
      type="button"
      onClick={() =>
        setOpenDropdown(openDropdown === type ? null : type)
      }
      className="w-full h-12 bg-slate-800 rounded-full border border-slate-700 hover:border-blue-500 px-5 flex justify-between items-center transition"
    >
      <span className="text-white truncate">
        {type === "project"
          ? selectedProjectData?.project || "Select"
          : selected.length > 0
          ? selected[0]
          : "Select"}
      </span>

      <ChevronDown
        size={20}
        className={`transition ${
          openDropdown === type ? "rotate-180" : ""
        }`}
      />
    </button>

    {openDropdown === type && (
      <div className="absolute left-0 mt-2 w-full bg-slate-800 border border-slate-700 rounded-lg shadow-lg max-h-60 overflow-y-auto z-50">

        {options.map((item) => {
          // Year Dropdown
          if (type === "year") {
            return (
              <div
                key={item}
                onClick={() => {
                  setSelected([item]);
                  setOpenDropdown(null);
                }}
                className={`flex items-center gap-3 px-4 py-3 cursor-pointer transition-colors ${
                  selected.includes(item)
                    ? "bg-gray-600 text-white"
                    : "text-white hover:bg-slate-700"
                }`}
              >
                <span className="w-1.5 h-1.5 rounded-full bg-white flex-shrink-0"></span>

                <span>{item}</span>
              </div>
            );
          }

          // Project Dropdown
          return (
            <div
              key={`${item.projectId}-${item.project}`}
              onClick={() => {
                setSelectedProjects([item.project]);
                setSelectedProjectData(item);
                setOpenDropdown(null);
              }}
              className={`flex items-center gap-3 px-4 py-3 cursor-pointer transition-colors ${
                selectedProjectData?.projectId === item.projectId
                  ? "bg-gray-600 text-white"
                  : "text-white hover:bg-slate-700"
              }`}
            >
              <span className="w-1.5 h-1.5 rounded-full bg-white flex-shrink-0"></span>

              <span className="whitespace-nowrap">{item.project}</span>
            </div>
          );
        })}
      </div>
    )}
  </div>
);

    const handleNext = () => {
        if (!selectedYears.length) {
            alert("Please select Year");
            return;
        }

        if (!selectedProjectData) {
            alert("Please select Project");
            return;
        }

        navigate(
            `/reporting-hub/software/${selectedProjectData.projectId}`,
            {
                state: {
                    projectId: selectedProjectData.projectId,
                    project: selectedProjectData.project,
                    year: selectedProjectData.year,
                    selectedProject: selectedProjectData,
                },
            }
        );
    };

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header */}
       <div className="flex items-center gap-4 px-2 sm:px-5 lg:px-9 pt-6">
         <button
            onClick={() => navigate('/project-reporting')}
            className=" rounded-full hover:bg-gray-800 transition-colors flex-shrink-0"
            aria-label="Go back"
          >
            <ArrowLeft className="w-6 h-6 sm:w-7 sm:h-7 md:w-6 md:h-6 font-bold" />
        </button>

        <h1 className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-bold leading-tight break-words">
        Project Reporting Hub_ Software
      </h1>
      </div>

      {/* Filters */}
      <div className="mt-12 px-4 sm:px-8 lg:px-16">
        <h2 className="text-2xl font-bold">Filters</h2>

        <div className="border-b border-gray-500 mt-2 mb-10"></div>

       <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
  {/* Year */}
  <div className="flex items-center sm:gap-4">
    <label className="sm:w-20 w-10 sm:text-lg text-sm font-semibold text-white whitespace-nowrap">
      Year
    </label>

    <div className="flex-1">
      {renderDropdown({
        options: years,
        selected: selectedYears,
        setSelected: setSelectedYears,
        type: "year",
        refObj: yearRef,
      })}
    </div>
  </div>

  {/* Project */}
  <div className="flex items-center sm:gap-4">
    <label className="sm:w-20 w-15 sm:text-lg text-sm font-semibold text-white whitespace-nowrap">
      Project
    </label>

    <div className="flex-1">
      {renderDropdown({
        options: projects,
        selected: selectedProjects,
        setSelected: setSelectedProjects,
        type: "project",
        refObj: projectRef,
      })}
    </div>
  </div>
</div>

        {/* Button */}
        <div className="flex justify-center sm:mt-50 mt-10">
          <button
          onClick={handleNext}
          disabled={!selectedYears.length || !selectedProjectData}
          className={`transition rounded-lg px-10 py-3 text-base font-semibold w-full sm:w-72 ${
            !selectedYears.length || !selectedProjectData
              ? "bg-gray-600 text-gray-300 cursor-not-allowed"
              : "bg-blue-600 hover:bg-blue-700 text-white"
          }`}
        >
          Done and Next
        </button>
        </div>
      </div>
    </div>
  );
};

export default ProjectReportingHub;